var map = {
	"./403": "./src/views/403.vue",
	"./403.vue": "./src/views/403.vue",
	"./404": "./src/views/404.vue",
	"./404.vue": "./src/views/404.vue",
	"./Home": "./src/views/Home.vue",
	"./Home.vue": "./src/views/Home.vue",
	"./Login": "./src/views/Login.vue",
	"./Login.vue": "./src/views/Login.vue",
	"./comm/AuthManager": "./src/views/comm/AuthManager.vue",
	"./comm/AuthManager.vue": "./src/views/comm/AuthManager.vue",
	"./comm/BaoSi": "./src/views/comm/BaoSi.vue",
	"./comm/BaoSi.vue": "./src/views/comm/BaoSi.vue",
	"./comm/BaoSiManager": "./src/views/comm/BaoSiManager.vue",
	"./comm/BaoSiManager.vue": "./src/views/comm/BaoSiManager.vue",
	"./comm/BillCenter": "./src/views/comm/BillCenter.vue",
	"./comm/BillCenter.vue": "./src/views/comm/BillCenter.vue",
	"./comm/FinancialCenter": "./src/views/comm/FinancialCenter.vue",
	"./comm/FinancialCenter.vue": "./src/views/comm/FinancialCenter.vue",
	"./comm/GrayRelease": "./src/views/comm/GrayRelease.vue",
	"./comm/GrayRelease.vue": "./src/views/comm/GrayRelease.vue",
	"./comm/GrayUser": "./src/views/comm/GrayUser.vue",
	"./comm/GrayUser.vue": "./src/views/comm/GrayUser.vue",
	"./comm/LogQuery": "./src/views/comm/LogQuery.vue",
	"./comm/LogQuery.vue": "./src/views/comm/LogQuery.vue",
	"./comm/OrderRecord": "./src/views/comm/OrderRecord.vue",
	"./comm/OrderRecord.vue": "./src/views/comm/OrderRecord.vue",
	"./comm/OrderRecord2": "./src/views/comm/OrderRecord2.vue",
	"./comm/OrderRecord2.vue": "./src/views/comm/OrderRecord2.vue",
	"./comm/PayManager": "./src/views/comm/PayManager.vue",
	"./comm/PayManager.vue": "./src/views/comm/PayManager.vue",
	"./comm/ProductManager": "./src/views/comm/ProductManager.vue",
	"./comm/ProductManager.vue": "./src/views/comm/ProductManager.vue",
	"./comm/QiYe": "./src/views/comm/QiYe.vue",
	"./comm/QiYe.vue": "./src/views/comm/QiYe.vue",
	"./comm/QiYeManager": "./src/views/comm/QiYeManager.vue",
	"./comm/QiYeManager.vue": "./src/views/comm/QiYeManager.vue",
	"./comm/Sale": "./src/views/comm/Sale.vue",
	"./comm/Sale.vue": "./src/views/comm/Sale.vue",
	"./components/SaleEntity": "./src/views/components/SaleEntity.vue",
	"./components/SaleEntity.vue": "./src/views/components/SaleEntity.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views sync recursive ^\\.\\/.*$";